function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { MessageItemTypes } from "../../enum/MessageItemTypes";
/**
 * 会議素材（メッセージ）アイテム　モデル
 */

var UploadMessageMaterialsItemInstanceModel =
/**
 * コンストラクタ
 *
 */
function UploadMessageMaterialsItemInstanceModel() {
  _classCallCheck(this, UploadMessageMaterialsItemInstanceModel);

  this.SessionId = -1;
  this.MessageId = -1;
  this.ItemId = -1;
  this.ItemName = "";
  this.ItemType = MessageItemTypes.Normal;
};

export { UploadMessageMaterialsItemInstanceModel as default };